import { PageDto, ProjectDto, PublicationDto } from 'app/core/cms/generated/api-types'
import { SocialShareData } from 'app/core/meta/social-share-data.type'

export function publicationSeoInfo(dto: PublicationDto): SocialShareData {
  return {
    title: dto.title || 'n/a',
    description: dto.excerpt ?? 'n/a',
    image: dto.image,

    type: 'article',
    modified: dto.updatedAt,
    published: dto.createdAt,
  }
}

export function pageSeoInfo(dto: PageDto): SocialShareData {
  return {
    title: dto.title || 'n/a',
    description: dto.excerpt || dto.hero?.[0]?.intro || 'n/a',
    image: dto.hero?.[0].image,

    type: 'website',
    modified: dto.updatedAt,
    published: dto.createdAt,
  }
}

export function projectSeoInfo(dto: ProjectDto): SocialShareData {
  return {
    title: dto.title || 'n/a',
    description: dto.excerpt || 'n/a',
    image: dto.image,

    type: 'website',
    modified: dto.updatedAt,
    published: dto.createdAt,
  }
}
